export const strapiImageUrl = (url: string) => {
    const imageUrl = `${process.env.admin_url}${url}`;
    return imageUrl
}